import React from 'react';
import '../styles/privacypolicy.css';

function PrivacyPolicy() {
  return (
    <section className="privacy-policy">
      <div className="container py-5">
        <h1 className="policy-title">Adatvédelmi tájékoztató</h1>

        <p className="policy-text">
          A FRDYPromotions elkötelezett a személyes adatok védelme iránt. Ez a tájékoztató bemutatja, hogyan kezeljük a weboldalunkon megadott adatokat.
        </p>

        <h2 className="policy-subtitle">1. Az adatkezelő adatai</h2>
        <p className="policy-text">
          Név: FRDYPromotions<br />
          Kapcsolat: info@frdypromotions.hu
        </p>

        <h2 className="policy-subtitle">2. Kezelt személyes adatok</h2>
        <ul className="policy-list">
          <li>Név</li>
          <li>E-mail cím</li>
          <li>Telefonszám (opcionális)</li>
          <li>Vállalkozás leírása</li>
          <li>Szolgáltatási terület</li>
          <li>Marketing kihívás</li>
          <li>Célkitűzés (6–12 hónap)</li>
          <li>Hirdetési tapasztalat</li>
          <li>Együttműködés típusa (opcionális)</li>
          <li>Egyéb megjegyzés (opcionális)</li>
        </ul>

        <h2 className="policy-subtitle">3. Az adatkezelés célja</h2>
        <p className="policy-text">
          Adataidat kizárólag azért kérjük be, hogy kapcsolatba tudjunk lépni veled, és hatékonyan felkészüljünk az ingyenes konzultációra.
        </p>

        <h2 className="policy-subtitle">4. Az adatkezelés jogalapja</h2>
        <p className="policy-text">
          Az adatkezelés az érintett hozzájárulásán alapul (GDPR 6. cikk (1) bekezdés a) pont).
        </p>

        <h2 className="policy-subtitle">5. Adatfeldolgozók</h2>
        <p className="policy-text">
          Az űrlap az EmailJS rendszeren keresztül kerül továbbításra az info@frdypromotions.hu címre. Az adatok nem kerülnek más rendszerbe vagy nyilvános megosztásra.
        </p>

        <h2 className="policy-subtitle">6. Adattárolás időtartama</h2>
        <p className="policy-text">
          A beküldött adatokat legfeljebb 12 hónapig őrizzük meg, vagy kérésre azonnal töröljük.
        </p>

        <h2 className="policy-subtitle">7. Cookie-k</h2>
        <p className="policy-text">
          Weboldalunk technikai célból minimális sütiket használ. Harmadik féltől származó statisztikai vagy marketing célú cookie-k csak a felhasználó hozzájárulásával aktiválódnak.
        </p>

        <h2 className="policy-subtitle">8. Érintetti jogok</h2>
        <p className="policy-text">
          Téged megillet:
        </p>
        <ul className="policy-list">
          <li>az adatokhoz való hozzáférés joga,</li>
          <li>helyesbítés joga,</li>
          <li>törléshez való jog,</li>
          <li>az adatkezelés korlátozásának joga,</li>
          <li>az adathordozhatósághoz való jog,</li>
          <li>tiltakozás joga.</li>
        </ul>
        <p className="policy-text">
          Ezen jogok gyakorlásához írj az <strong>info@frdypromotions.hu</strong> címre.
        </p>

        <h2 className="policy-subtitle">9. Jogorvoslat</h2>
        <p className="policy-text">
          Panasszal élhetsz a Nemzeti Adatvédelmi és Információszabadság Hatóságnál (NAIH).<br />
          Weboldal: <a href="https://naih.hu" target="_blank" rel="noopener noreferrer">https://naih.hu</a>
        </p>
      </div>
    </section>
  );
}

export default PrivacyPolicy;
